// extracted by mini-css-extract-plugin
export var arrows = "_8j-6";
export var decrementer = "_8j-a";
export var disabled = "_8j-4";
export var error = "_8j-1";
export var hiddenText = "_8j-b";
export var incrementer = "_8j-9";
export var input = "_8j-8";
export var inputWrapper = "_8j-0";
export var leadingIcon = "_8j-c";
export var readonly = "_8j-3";
export var regular = "_8j-7";
export var small = "_8j-5";
export var warning = "_8j-2";